export default {
  featuredArticlesTitle: {
    id: 'product_comparison_buying_guides_title',
    defaultMessage: 'Our featured articles',
  },
}
